import React from 'react';
import {
    CheckCircleFilled,
    ClockCircleFilled,
    CloseCircleFilled,
} from '@ant-design/icons';
import { Text } from '@clockout-dev/design-elements';
import { BILLING_STATEMENT_STATUS } from '../billing.constants';
import styles from './styles/statement-status-pill.module.scss';

const ICONS = {
    [BILLING_STATEMENT_STATUS.PAID]: <CheckCircleFilled />,
    [BILLING_STATEMENT_STATUS.PENDING]: <ClockCircleFilled />,
    [BILLING_STATEMENT_STATUS.OVERDUE]: <CloseCircleFilled />,
};

const LABELS = {
    [BILLING_STATEMENT_STATUS.PAID]: 'Paid',
    [BILLING_STATEMENT_STATUS.PENDING]: 'Pending',
    [BILLING_STATEMENT_STATUS.OVERDUE]: 'Overdue',
};

const TONES = {
    [BILLING_STATEMENT_STATUS.PAID]: styles.statusSuccess,
    [BILLING_STATEMENT_STATUS.PENDING]: styles.statusWarning,
    [BILLING_STATEMENT_STATUS.OVERDUE]: styles.statusDanger,
};

/**
 * Status indicator for billing statements — matches Cashflow Management
 * `TransactionStatusPill`: inline icon + label, tone colour only (no
 * background pill).
 */
function StatementStatusPill({ status }) {
    const normalized = (status || '').toLowerCase();
    const isKnown = Boolean(TONES[normalized]);
    const tone = isKnown ? TONES[normalized] : styles.statusNeutral;
    const label = isKnown
        ? LABELS[normalized]
        : normalized
            ? normalized.replace(/_/g, ' ')
            : '—';

    return (
        <span className={`${styles.pill} ${tone}`}>
            {isKnown ? (
                <span className={styles.icon} aria-hidden="true">
                    {ICONS[normalized]}
                </span>
            ) : null}
            <Text as="span" size="xs" className={styles.label}>
                {label}
            </Text>
        </span>
    );
}

export default StatementStatusPill;
